var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card-container" },
    [
      _c(
        "el-col",
        { staticClass: "card-row", attrs: { xs: 24, sm: 8 } },
        [
          _c("app-card", {
            attrs: {
              title: "Total de processos",
              value: _vm.totalProcessos,
              img: "NUM_PROCESSOS",
              numericValue: true
            }
          })
        ],
        1
      ),
      _c(
        "el-col",
        { staticClass: "card-row", attrs: { xs: 24, sm: 8 } },
        [
          _c("app-card", {
            attrs: {
              title: "Tipo de processo com mais solicitações",
              value: _vm.maisSolicitado.label,
              subValue: _vm.maisSolicitado.valor,
              img: "MAIS_SOLICITADO"
            }
          })
        ],
        1
      ),
      _c(
        "el-col",
        { staticClass: "card-row", attrs: { xs: 24, sm: 8 } },
        [
          _c("app-card", {
            attrs: {
              title: "Município com mais solicitações",
              value: _vm.municipioMaisSolicitacoes.label,
              subValue: _vm.municipioMaisSolicitacoes.valor,
              img: "MUNICIPIO"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-109441f5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-109441f5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/components/home/TheDashboard.vue
// module id = null
// module chunks = 